import { PerfilesService } from './../../services/perfiles.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-perfiles',
  templateUrl: './perfiles.component.html',
  styleUrls: ['./perfiles.component.css']
})
export class PerfilesComponent implements OnInit {

  perfiles=[];
  filtro:{}={
    nombre:"",
    permisos:""
  }
  constructor(private perfilesService:PerfilesService) { }

  ngOnInit() {
    this.getPerfilesPorFiltro();
  }

  getPerfilesPorFiltro(){
    this.perfilesService.getPerfiles(this.filtro).subscribe(resp=>{
      this.perfiles=resp["perfiles"];
    })
  }

  checkLimitado(i){
    let returnValue=false;
    if(this.perfiles[i].PEusuario=="1"){
      returnValue=true;
    }
    return returnValue;
  
  }

  checkInterviniente(i){
    let returnValue=false;
    if(this.perfiles[i].PEinterviniente=="1"){
      returnValue=true;
    }
    return returnValue;
    
  }

  checkAdministrador(i){
    let returnValue=false;
    if(this.perfiles[i].PEadmin=="1"){
      returnValue=true;
    }
    return returnValue;
  }
  
  limpiarFiltros(){
    this.filtro={
      nombre:"",
      permisos:""
    }
  }

  verTodos(){
    this.limpiarFiltros();
    this.getPerfilesPorFiltro();
    
  }

  borrarPerfil(codPerfil){
    if(confirm("¿Desea borrar el perfil seleccionado?")){
      this.perfilesService.borrarPerfil(codPerfil)
      .subscribe(resp=>{
        alert(resp["msg"]);
        this.getPerfilesPorFiltro();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/perfiles/perfiles.component.ts